export default {
    LOGIN_SUCCESS: "heimdall_login_success",
    LOGIN_INVALID_CREDENTIALS: "heimdall_login_invalid_credentials",
    LOGIN_TOO_MANY_ATTEMPTS: "heimdall_login_too_many_attempts",
    LOGIN_TOTP_CODE_NEEDED: "heimdall_login_totp_code_needed",
    LOGIN_INVALID_CODE: "heimdall_login_invalid_code",
    EMAIL_VERIFICATION_RESEND_SUCCESS: "heimdall_email_verification_resend_success",
    EMAIL_VERIFICATION_RESEND_ERROR: "heimdall_email_verification_resend_error",
    EMAIL_VERIFICATION_RESEND_START: "heimdall_email_verification_resend_start",
    EMAIL_VERIFICATION_SUCCESS: "heimdall_email_verification_success",
    EMAIL_VERIFICATION_ERROR: "heimdall_email_verification_error",
    ACTIVATE_EMAIL_SUCCESS: "heimdall_activate_email_success",
    ACTIVATE_EMAIL_ERROR: "heimdall_activate_email_error",
    POSTPONE_PASSWORD_CHANGE: "heimdall_postpone_password_change",
    PASSWORD_RESET_REQUEST_SUCCESS: "heimdall_password_reset_request_success",
    PASSWORD_RESET_REQUEST_ERROR: "heimdall_password_reset_request_error",
    REGISTRATION_TOKEN_VERIFICATION_SUCCESS: "heimdall_registration_token_verification_success",
    REGISTRATION_TOKEN_VERIFICATION_ERROR: "heimdall_registration_token_verification_error",
    REGISTRATION_SUCCESS: "heimdall_registration_success",
    REGISTRATION_ERROR: "heimdall_registration_error",
    ADD_ROLE: "heimdall_add_role",
    ADD_ROLE_ERROR: "heimdall_add_role_error",
};

export const tokenResourceCreatedEventName = "token_resource_created";
